<div class="ng-footer" style="padding: 5px;">
  <div class="p-grid">
    <div class="p-lg-2 p-md-12 p-col-12 no-padding-margin visitors">
      <span>Visitors: {{ view }}</span>
    </div>
    <div class="p-lg-8 p-md-12 p-col-12 no-padding-margin"  style="text-align: center;">
      <span class="color-red">&#9788;</span> Copyright © {{ year }} S&S Auditing & Consulting Co., Ltd. All Rights Reserved <span class="color-red">&#9750;</span>
    </div>
    <div class="p-lg-2 p-md-12 p-col-12 no-padding-margin">
    </div>
  </div>
</div>